<template>
  <div class="container-lg">
    <div class="buscador card">
      <div class="card-body">
        <form v-on:submit.prevent="clickBuscar()">
          <div class="input-group">
            <input
              v-model="busqueda.valor"
              type="search"
              class="form-control"
              placeholder="Buscar"
              aria-label="Valor a buscar"
              aria-describedby="icono-buscar"
            />
            <button class="input-group-text" type="submit">
              <font-awesome-icon :icon="Icons.BUSCAR" />
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="resultados">
      <div
        class="accordion open"
        id="accordionExample"
        v-on:[`hide.bs.collapse`]="accordionCerrado()"
      >
        <div
          class="accordion-item"
          v-on:[`shown.bs.collapse`]="accordionExpandido(0)"
        >
          <h2 class="accordion-header" id="headingFiltro">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFiltro"
              aria-expanded="false"
              aria-controls="collapseFiltro"
            >
              Filtrar
            </button>
          </h2>
          <div
            id="collapseFiltro"
            class="accordion-collapse collapse"
            aria-labelledby="headingFiltro"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <Filtro
                v-on:cambio-buscar-por="filtroBuscarPorCambiado"
                v-on:cambio-ordenar-por="filtroOrdenarPorCambiado"
                class="filtro"
              />
            </div>
          </div>
        </div>
        <div
          class="accordion-item"
          v-on:[`shown.bs.collapse`]="accordionExpandido(1)"
        >
          <h2 class="accordion-header" id="headingBeneficios">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseBeneficios"
              aria-expanded="true"
              aria-controls="collapseBeneficios"
            >
              Beneficios
            </button>
          </h2>
          <div
            id="collapseBeneficios"
            class="accordion-collapse collapse show"
            aria-labelledby="headingBeneficios"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <TablaBeneficios
                ref="beneficios"
                :busqueda="busqueda"
                :cargaManual="true"
                :comercioList="comercioList"
                :facade="BeneficioFacade"
                :infoSinResultados="
                  'Prueba cambiar la búsqueda o aplicar otros filtros'
                "
                :mostrarEditar="true"
                :mostrarEliminar="true"
                :permitePrioridad="false"
              />
            </div>
          </div>
        </div>
        <div
          class="accordion-item"
          v-on:[`shown.bs.collapse`]="accordionExpandido(2)"
        >
          <h2 class="accordion-header" id="headingComercios">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseComercios"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Comercios
            </button>
          </h2>
          <div
            id="collapseComercios"
            class="accordion-collapse collapse"
            aria-labelledby="headingComercios"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <TablaComercios
                ref="comercios"
                :busqueda="busqueda"
                :cargaManual="true"
                :facade="ComercioFacade"
                :infoSinResultados="
                  'Prueba cambiar la búsqueda o aplicar otros filtros'
                "
                :mostrarEditar="true"
                :mostrarEliminar="true"
              />
            </div>
          </div>
        </div>
        <div
          class="accordion-item"
          v-on:[`shown.bs.collapse`]="accordionExpandido(3)"
        >
          <h2 class="accordion-header" id="headingComentarios">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseComentarios"
              aria-expanded="false"
              aria-controls="collapseComentario"
            >
              Comentarios
            </button>
          </h2>
          <div
            id="collapseComentarios"
            class="accordion-collapse collapse"
            aria-labelledby="headingComentarios"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <PanelComentarios
                ref="comentarios"
                :busqueda="busqueda"
                :cargaManual="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { BeneficioFacade } from "../../admin/beneficio/beneficio.facade";
import { BuscarPor, OrdenarPor } from "../../data/enums";
import { ComercioFacade } from "../../admin/comercio/comercio.facade";
import Filtro from "../Filtro";
import { Icons as IconConstants } from "../../constants";
import PanelComentarios from "./PanelComentarios.vue";
import TablaBeneficios from "./tablas/TablaBeneficios.vue";
import TablaComercios from "./tablas/TablaComercios.vue";
import { Util } from "../../util";

export default {
  components: {
    FontAwesomeIcon,

    Filtro,
    PanelComentarios,
    TablaBeneficios,
    TablaComercios
  },
  computed: {
    BeneficioFacade() {
      return BeneficioFacade;
    },
    ComercioFacade() {
      return ComercioFacade;
    },
    Icons() {
      return IconConstants;
    }
  },
  data() {
    return {
      busqueda: {
        valor: this.Busqueda,
        buscarPor: BuscarPor.comercio,
        ordenarPor: OrdenarPor.relevancia
      },
      // Se utilizan para no recargar datos si una búsqueda ya se hizo
      busquedasCacheadas: {
        beneficios: null,
        comercios: null,
        comentarios: null
      },
      comercioList: undefined,
      /** Indice del accordion mostrado actualmente */
      indiceAccordion: 1,
      token: ""
    };
  },
  created() {
    ComercioFacade.getActiveList().then(response => {
      this.comercioList = response.data;
    });
  },
  // TODO: eliminar comentarios y beneficios correspondientes a un comercio eliminado
  methods: {
    // Se llama cuando se cierra un accordion-item
    // Tener en cuenta que al abrirse uno, primero se cierra el que estaba abierto antes
    // (Si es que había uno abierto)
    accordionCerrado() {
      this.indiceAccordion = null;
    },
    accordionExpandido(indice) {
      this.indiceAccordion = indice;

      this.tratarActualizacion();
    },
    // Cuando se hace click en el botón buscar o se apreta Enter en el input de búsqueda
    clickBuscar() {
      this.tratarActualizacion();
    },
    filtroBuscarPorCambiado(valor) {
      if (valor == this.busqueda.buscarPor) return;

      // Reconstruir el objeto para que se detecten los cambios en los componentes que lo usan
      this.busqueda = {
        valor: this.busqueda.valor,
        buscarPor: valor,
        ordenarPor: this.busqueda.ordenarPor
      };

      this.tratarActualizacion();
    },
    filtroOrdenarPorCambiado(valor) {
      if (valor == this.busqueda.ordenarPor) return;

      // Reconstruir el objeto para que se detecten los cambios en los componentes que lo usan
      this.busqueda = {
        valor: this.busqueda.valor,
        buscarPor: this.busqueda.buscarPor,
        ordenarPor: valor
      };

      this.tratarActualizacion();
    },
    // Se fija si la lista en el accordion expandido necesita actualizarse
    tratarActualizacion() {
      switch (this.indiceAccordion) {
        // Beneficios
        case 1:
          if (this.verSiEsDistinta(this.busquedasCacheadas.beneficios)) {
            // Se hace una copia profunda para que no queden valores enlazados
            // Con enlazado me refiero a que al cambiar en un objeto cambien en el otro
            this.busquedasCacheadas.beneficios = Util.copiaProfunda(
              this.busqueda
            );
            // Llamar al EventoRecargar dentro del componente referenciado
            this.$refs.beneficios.EventoRecargar(this.busqueda);
          }
          break;
        // Comercios
        case 2:
          if (this.verSiEsDistinta(this.busquedasCacheadas.comercios)) {
            // Se hace una copia profunda para que no queden valores enlazados
            // Con enlazado me refiero a que al cambiar en un objeto cambien en el otro
            this.busquedasCacheadas.comercios = Util.copiaProfunda(
              this.busqueda
            );
            // Llamar al EventoRecargar dentro del componente referenciado
            this.$refs.comercios.EventoRecargar(this.busqueda);
          }
          break;
        // Comentarios
        case 3:
          if (this.verSiEsDistinta(this.busquedasCacheadas.comentarios)) {
            // Se hace una copia profunda para que no queden valores enlazados
            // Con enlazado me refiero a que al cambiar en un objeto cambien en el otro
            this.busquedasCacheadas.comentarios = Util.copiaProfunda(
              this.busqueda
            );
            // Llamar al EventoRecargar dentro del componente referenciado
            this.$refs.comentarios.EventoRecargar(this.busqueda);
          }
          break;
        default:
          break;
      }
    },
    /** Verdadero si la búsqueda cacheada es distinta a la actual */
    verSiEsDistinta(cacheada) {
      if (cacheada == null) return true;

      if (cacheada.valor != this.busqueda.valor) return true;

      if (cacheada.buscarPor != this.busqueda.buscarPor) return true;

      if (cacheada.ordenarPor != this.busqueda.ordenarPor) return true;

      return false;
    }
  },
  mounted() {
    this.token = localStorage.getItem("token");

    // Inicializar lista mostrada por defecto en accordion

    // Se hace una copia profunda para que no queden valores enlazados
    // Con enlazado me refiero a que al cambiar en un objeto cambien en el otro
    this.busquedasCacheadas.beneficios = Util.copiaProfunda(this.busqueda);
    this.$refs.beneficios.EventoRecargar(this.busqueda);
  }
};
</script>

<style scoped>
.buscador,
.resultados {
  margin-top: 10px;
}
.accordion-body > * {
  padding: 0;
}

.accordion-body div {
  justify-content: center;
}
</style>
